// extracted by css-extract-rspack-plugin
export default {"chip":"chip-module__chip","chipLabel":"chip-module__chipLabel","chipDesktop":"chip-module__chipDesktop"};